module.exports = __webpack_public_path__ + "static/media/slide.7ddf8e87.png";